// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s6-0";
export var leftAlign = "_s6-4";
export var listItem = "_s6-2";
export var listItemWrapper = "_s6-1";
export var operationText = "_s6-3";